module.exports = __webpack_public_path__ + "img/icon_success_color.ff4618d1.svg";